import { SafeAreaView } from "@stepapp/ui";
import { useLocalSearchParams, useRouter } from "expo-router";
import { useCallback, useState } from "react";
import { StyleSheet } from "react-native";
import { EditReservationScreen } from "../../../src/screens";

const EditReservation = () => {
  const { back, replace } = useRouter();
  const [newReservationId, setNewReservationId] = useState("");
  const { reservationId = "", questionToEdit = "" } = useLocalSearchParams<{
    reservationId: string;
    questionToEdit: string;
  }>();

  const handleClose = useCallback(() => {
    newReservationId ? replace(`calendar/${newReservationId}`) : back();
  }, [back, replace, newReservationId]);

  return (
    <SafeAreaView edges={["bottom"]} style={styles.container}>
      <EditReservationScreen
        reservationId={reservationId}
        questionToEdit={questionToEdit}
        handleGoBack={handleClose}
        setNewReservationId={setNewReservationId}
      />
    </SafeAreaView>
  );
};

export default EditReservation;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
